var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{attrs:{"id":"AccountScreen"}},[_c('h2',{attrs:{"id":"AccountScreen__Title"}},[_vm._v(" Account Information ")]),_c('AccountEdit',{attrs:{"id":"AccountScreen__Form"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }